module.exports = __webpack_public_path__ + "static/media/bell.2a762881.SVG";